import { application } from "./application"

import NavController       from "./nav_controller"
import RevealController    from "./reveal_controller"
import CounterController   from "./counter_controller"
import TabsController      from "./tabs_controller"
import CarouselController         from "./carousel_controller"
import HorizontalScrollController from "./horizontal_scroll_controller"
import ServiceScrollController    from "./service_scroll_controller"

application.register("nav",               NavController)
application.register("reveal",            RevealController)
application.register("counter",           CounterController)
application.register("tabs",              TabsController)
application.register("carousel",          CarouselController)
application.register("horizontal-scroll", HorizontalScrollController)
application.register("service-scroll",    ServiceScrollController)
